import { Component, Injectable } from '@angular/core';

@Component({
  selector: 'app-create-account-closed',
  templateUrl: './create-account-closed.component.html',
  styleUrls: ['./create-account-closed.component.scss'],
  standalone: false
})
@Injectable()
export class CreateAccountClosedComponent {}
